import React from "react";
import PropTypes from "prop-types";
import GenericModal from "../../../Components/Modals/GenericModal";
import UnderPaymentList from "./UnderPaymentList";
import UnderPaymentDetail from "./UnderPaymentDetail";
import "./UnderPaymentModal.scss";

export default function UnderPaymentModal({ open, setOpen, selectedRecord, onSelectRecord, onBackToList, projectIds }) {
  const handleClose = () => setOpen(false);

  return (
    <GenericModal open={open} setOpen={handleClose} className="UnderPaymentModal">
      <div className={`UnderPaymentModal-listPane ${selectedRecord ? "UnderPaymentModal-listPane--hidden" : ""}`}>
        <UnderPaymentList onSelectRecord={onSelectRecord} onClose={handleClose} projectIds={projectIds} />
      </div>
      {selectedRecord && (
        <div className="UnderPaymentModal-detailPane">
          <UnderPaymentDetail record={selectedRecord} onBackToList={onBackToList} />
        </div>
      )}
    </GenericModal>
  );
}

UnderPaymentModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  selectedRecord: PropTypes.object,
  onSelectRecord: PropTypes.func.isRequired,
  onBackToList: PropTypes.func.isRequired,
  projectIds: PropTypes.string
};

UnderPaymentModal.defaultProps = {
  open: false,
  selectedRecord: null,
  projectIds: ""
};